import React from "react"
import styles from "../HotelRoomSelectorV2.module.scss"
import IconsColor from "../../../../util/iconsColor"

interface ToolbarProps {
  search: string
  setSearch: (value: string) => void
  starFilter: string
  setStarFilter: (value: string) => void
  sort: string
  setSort: (value: string) => void
}

const Toolbar: React.FC<ToolbarProps> = ({
  search,
  setSearch,
  starFilter,
  setStarFilter,
  sort,
  setSort,
}) => (
  <div className={styles.toolbar}>
    <div className={styles.searchWrap}>
      <span className={styles.searchIcon}><IconsColor iconName="searchIcon" width="12px" height="12px" fillColor="none" strokeColor="currentColor" /></span>
      <input
        autoFocus={true}
        aria-label="Search hotel or room type"
        placeholder="Search hotel or room type"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={styles.searchInput}
      />
    </div>
    <select className={styles.selectField} value={starFilter} onChange={(e) => setStarFilter(e.target.value)}>
      <option value="all">All Stars</option>
      <option value="5">5 Stars</option>
      <option value="4">4 Stars</option>
      <option value="3">3 Stars</option>
    </select>
    <select className={styles.selectField} value={sort} onChange={(e) => setSort(e.target.value)}>
      <option value="default">Pricing</option>
      <option value="price_asc">Low → High</option>
      <option value="price_desc">High → Low</option>
    </select>
  </div>
)

export default Toolbar
